import { startTransition, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const useSidebarMenu = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);
  const signerType: Record<string, string> = {
    first: t('homePage.firstSignature'),
    second: t('homePage.secondSignature'),
  };

  const navigate = useNavigate();
  const [isOpenLogoutModal, updateLogoutModal] = useState<boolean>(false);

  const openLogoutModal = () => {
    updateLogoutModal(true);
  };

  const closeLogOutModal = () => {
    updateLogoutModal(false);
  };

  const handleLogout = () => {
    startTransition(() => {
      navigate(`${lang}/login`);
    });
    window.sessionStorage.clear();
  };

  return {
    t,
    lang,
    signerType,
    isOpenLogoutModal,
    closeLogOutModal,
    openLogoutModal,
    handleLogout,
  };
};
export default useSidebarMenu;
